function normalizeAngle(angle) {
  return (angle + Math.PI * 2) % (Math.PI * 2);
}

export function shortestAngleDifference(from, to) {
  const a = normalizeAngle(from);
  const b = normalizeAngle(to);
  let diff = b - a;
  if (diff > Math.PI) diff -= Math.PI * 2;
  if (diff < -Math.PI) diff += Math.PI * 2;
  return diff;
}